import { CalendarSlotRange } from "./CalendarSlotRange";


export class CalendarSaveGeneratedInput {
  roomId: number;
  birthdayZoneId: number;
  slots: CalendarSlotRange[];
  isFlexible:boolean;
  payLoad:any
  constructor() {
    this.roomId = null as unknown as number;
    this.birthdayZoneId = null as unknown as number;
    this.slots = [];
    this.isFlexible=false
    this.payLoad=null
  }
}
